"use strict";
/*
 * Created on 27. 2. 2019
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _construct = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/construct");

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var AsyncConsumer_1 = require("./AsyncConsumer");
/**
 * Abstraction of consumer (sink) with back pressure implemented by promise.
 * @author Stepan Mik
 */


var BufferingConsumer =
/*#__PURE__*/
function (_AsyncConsumer_1$Asyn) {
  _inherits(BufferingConsumer, _AsyncConsumer_1$Asyn);

  function BufferingConsumer() {
    var _this;

    _classCallCheck(this, BufferingConsumer);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(BufferingConsumer).call(this));
    _this.prev = Promise.resolve();

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var size = args[0],
        init = args[1];
    _this.size = size;
    _this.initAcc = init;
    return _this;
  }

  _createClass(BufferingConsumer, [{
    key: "init",
    value: function init() {
      this.buffer = immutable_1.List().asMutable();
      this.acc = this.initAcc;
      return _get(_getPrototypeOf(BufferingConsumer.prototype), "init", this).call(this);
    }
  }, {
    key: "finalize",
    value: function () {
      var _finalize = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.prev;

              case 2:
                if (this.buffer.isEmpty()) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this.invokeProcess(this.buffer.asImmutable());

              case 5:
                this.buffer = immutable_1.List().asMutable();

              case 6:
                return _context.abrupt("return", this.acc);

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      return function finalize() {
        return _finalize.apply(this, arguments);
      };
    }()
  }, {
    key: "consume",
    value: function consume(value) {
      var _this2 = this;

      this.buffer = this.buffer.push(value);

      if (this.buffer.size < this.size) {
        return null;
      }

      var b = this.buffer.asImmutable();
      this.buffer = immutable_1.List().asMutable();
      var p = this.prev;
      this.prev = this.prev.then(function () {
        return _this2.invokeProcess(b);
      });
      return p;
    }
  }, {
    key: "invokeProcess",
    value: function () {
      var _invokeProcess = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(buffer) {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.process(buffer);

              case 2:
                res = _context2.sent;
                _context2.next = 5;
                return this.reduce(this.acc, res);

              case 5:
                this.acc = _context2.sent;

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      return function invokeProcess(_x) {
        return _invokeProcess.apply(this, arguments);
      };
    }()
  }]);

  return BufferingConsumer;
}(AsyncConsumer_1.AsyncConsumer);

exports.BufferingConsumer = BufferingConsumer; // tslint:disable-next-line:no-namespace

var BufferingConsumers;

(function (BufferingConsumers) {
  function fromFunction(size, processor) {
    // tslint:disable-next-line:max-classes-per-file
    return new (
    /*#__PURE__*/
    function (_BufferingConsumer) {
      _inherits(_class, _BufferingConsumer);

      function _class() {
        _classCallCheck(this, _class);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class).apply(this, arguments));
      }

      _createClass(_class, [{
        key: "process",
        value: function process(buffer) {
          return processor(buffer);
        }
      }, {
        key: "reduce",
        value: function reduce(acc, res) {
          /**/
        }
      }]);

      return _class;
    }(BufferingConsumer))(size);
  }

  BufferingConsumers.fromFunction = fromFunction;

  function fromFunctionAndReducer(size, initial, processor, reducer) {
    // tslint:disable-next-line:max-classes-per-file
    return _construct(
    /*#__PURE__*/
    function (_BufferingConsumer2) {
      _inherits(_class2, _BufferingConsumer2);

      function _class2() {
        _classCallCheck(this, _class2);

        return _possibleConstructorReturn(this, _getPrototypeOf(_class2).apply(this, arguments));
      }

      _createClass(_class2, [{
        key: "process",
        value: function process(buffer) {
          return processor(buffer);
        }
      }, {
        key: "reduce",
        value: function reduce(acc, res) {
          return reducer(acc, res);
        }
      }]);

      return _class2;
    }(BufferingConsumer), [size, initial]);
  }

  BufferingConsumers.fromFunctionAndReducer = fromFunctionAndReducer;
})(BufferingConsumers = exports.BufferingConsumers || (exports.BufferingConsumers = {}));